var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3962 8.33333C16.972 7.12977 15.8586 6.30505 14.5837 6.25H10.417C8.6911 6.25 7.29199 7.64911 7.29199 9.375C7.29199 11.1009 8.6911 12.5 10.417 12.5H14.5837C16.3095 12.5 17.7087 13.8991 17.7087 15.625C17.7087 17.3509 16.3095 18.75 14.5837 18.75H10.417C9.14206 18.695 8.02868 17.8702 7.60449 16.6667",
    stroke: "#6F6B7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2503 3.125C13.2503 2.71079 12.9145 2.375 12.5003 2.375C12.0861 2.375 11.7503 2.71079 11.7503 3.125H13.2503ZM11.7503 6.25C11.7503 6.66421 12.0861 7 12.5003 7C12.9145 7 13.2503 6.66421 13.2503 6.25H11.7503ZM13.2503 18.75C13.2503 18.3358 12.9145 18 12.5003 18C12.0861 18 11.7503 18.3358 11.7503 18.75H13.2503ZM11.7503 21.875C11.7503 22.2892 12.0861 22.625 12.5003 22.625C12.9145 22.625 13.2503 22.2892 13.2503 21.875H11.7503ZM11.7503 3.125V6.25H13.2503V3.125H11.7503ZM11.7503 18.75V21.875H13.2503V18.75H11.7503Z",
    fill: "#4B465C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2503 3.125C13.2503 2.71079 12.9145 2.375 12.5003 2.375C12.0861 2.375 11.7503 2.71079 11.7503 3.125H13.2503ZM11.7503 6.25C11.7503 6.66421 12.0861 7 12.5003 7C12.9145 7 13.2503 6.66421 13.2503 6.25H11.7503ZM13.2503 18.75C13.2503 18.3358 12.9145 18 12.5003 18C12.0861 18 11.7503 18.3358 11.7503 18.75H13.2503ZM11.7503 21.875C11.7503 22.2892 12.0861 22.625 12.5003 22.625C12.9145 22.625 13.2503 22.2892 13.2503 21.875H11.7503ZM11.7503 3.125V6.25H13.2503V3.125H11.7503ZM11.7503 18.75V21.875H13.2503V18.75H11.7503Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollarIcon.a5159da19c927f3741b4599221eb1877.svg";
export { ForwardRef as ReactComponent };